import React from "react"

import { FALLBACK_SEO_IMAGE } from "../../shared-components/seo"
import { CanonicalTag } from "../../shared-components/seo/canonical-tag"
import { usePageTracking } from "../../shared-components/seo/use-page-tracking"
import { SeoMetaTag } from "./types"

const MISSING_TITLE_ERROR_MESSAGE =
  "Error: seo title property is missing from Dato"

function getTagsWithImageFallback(data: SeoMetaTag[]): SeoMetaTag[] {
  const hasImage = data.some(item => {
    if (item.tag === "meta") {
      return /^(.*:)?image$/g.test(item.attributes?.property ?? "")
    }
    return false
  })

  const imageTags = hasImage
    ? []
    : [
        {
          tag: "meta",
          attributes: {
            property: "og:image",
            content: FALLBACK_SEO_IMAGE,
          },
        },
        {
          tag: "meta",
          attributes: {
            name: "twitter:image",
            content: FALLBACK_SEO_IMAGE,
          },
        },
      ]
  return [...imageTags, ...data]
}

interface Props {
  seoMetaTags: SeoMetaTag[]
  pathname: string
  nonCrawlable?: boolean
}

const DatoSeo = ({ seoMetaTags, pathname, nonCrawlable }: Props) => {
  const tags = getTagsWithImageFallback(seoMetaTags)
  const title = tags.find(tag => tag.tag === "title")?.content

  usePageTracking(title ?? MISSING_TITLE_ERROR_MESSAGE, pathname)
  return (
    <>
      {title && <title>{title}</title>}
      <CanonicalTag pathname={pathname} />
      {nonCrawlable && <meta name="robots" content="noindex" />}
      {tags
        .filter(tag => !!tag?.attributes)
        .map(tag => (
          <meta
            key={`${tag?.attributes?.property || tag?.attributes?.name}-${tag?.attributes?.content}`}
            name={tag?.attributes?.name}
            property={tag?.attributes?.property}
            content={
              tag?.attributes?.name === "twitter:card"
                ? "content_summary_large"
                : String(tag?.attributes?.content)
            }
          />
        ))}
    </>
  )
}

export default DatoSeo
